import React, { Component } from 'react';
import { numberWithCommas } from '../utility/tool';
import Tabs from 'muicss/lib/react/tabs';
import Tab from 'muicss/lib/react/tab';
import IconButton from 'material-ui/IconButton';
import $ from 'jquery';

const infoIconStyle = {
  iconStyle: {
  	color:"#333",
  },
  blueIcon: {
  	color:"#1f90e5",
  },
  tooltipText: {
  	textAlign:'left'
  },
  tooltipStyle: {
    fontSize:'14px',
    fontWeight:'300',
    padding:'5px 10px'
  },
}

export default class ProfileSourceTab extends Component{
	renderFbTab(fbData){
		if(!fbData.hasOwnProperty('fans_scale')){
			return <Tab value="pane-1" label="Facebook 經營績效" />
		}
		const fbPerAvg_reaction = Math.round(fbData.performance.avg_reaction * 100) / 100
		const fbLoyalty = (fbData.performance.loyalty * 100).toFixed(2)
		const fbReatAvg_reaction = Math.round(fbData.reaction.avg_reaction)
		const fbReaLike = Math.round(fbData.reaction.avg_like)
		const fbReaComment = Math.round(fbData.reaction.avg_comment)
		const fbReaShare = Math.round(fbData.reaction.avg_share)
		const fbViewed = fbData.viewed.viewed === null ? 'N/A':numberWithCommas(Math.round(fbData.viewed.viewed))

		return (
  			<Tab value="pane-1" label="Facebook 經營績效">
  				<div className="dataBoxWrap">
  					<div className="boxContent">
	  					<p className="boxTitle">粉絲規模</p>
	  					<div className="boxInfo">
	  						<div className="mainSection">
	  							<div className="profileTab fb_fansScale"></div>
	  							<div className="title">
	  								<p className="item">粉絲人數</p>
	  								<p className="number">{numberWithCommas(fbData.fans_scale.fans_scale)}</p>
	  							</div>
	  						</div>
	  						<IconButton
	  						  className="infoIcon"
	  						  iconClassName="material-icons"
	  						  iconStyle={infoIconStyle.iconStyle}
	  						  tooltip={
	  						  	<div style={infoIconStyle.tooltipText}>
	  						  	  粉絲人數 : 說粉專讚的人數。<br/>
	  						  	  追蹤人數 : 正在追蹤粉專的人數。<br/>
								  <br/>
								  註：<br/>
                                  因facebook粉專改版，新版粉專的<br/>
								  粉絲數逐步以追踪人數取代。
	  						  	</div>
	  						  }
	  						  tooltipPosition="top-right"
	  						  tooltipStyles={infoIconStyle.tooltipStyle}
	  						>
	  						  info
	  						</IconButton>
	  					</div>
	  				</div>
  				</div>
  				<div className="dataBoxWrap">
  					<div className="boxContent">
  						<p className="boxTitle">粉絲成長</p>
	  					<div className="boxInfo">
	  						<div className="mainSection">
	  							<div className="profileTab fb_growth"></div>
	  							<div className="title">
	  								<p className="item">粉絲成長數</p>
	  								<p className="number">{numberWithCommas(fbData.growth.growth)}</p>
	  							</div>
	  						</div>
	  						<IconButton
	  						  className="infoIcon"
	  						  iconClassName="material-icons"
	  						  iconStyle={infoIconStyle.iconStyle}
	  						  tooltip={
	  						  	<div style={infoIconStyle.tooltipText}>
	  						  	  粉絲成長數 : 查詢區間內，粉絲的總新增(或減少)人數。
	  						  	</div>
	  						  }
	  						  tooltipPosition="top-right"
	  						  tooltipStyles={infoIconStyle.tooltipStyle}
	  						>
	  						  info
	  						</IconButton>
	  					</div>
  					</div>
  				</div>
  				<div className="dataBoxWrap">
  					<div className="boxContent">
	  					<p className="boxTitle">粉絲經營</p>
	  					<div className="boxInfo">
	  						<div className="mainSection">
	  							<div className="profileTab fb_performance"></div>
	  							<div className="title">
	  								<p className="item">粉絲平均互動數</p>
	  								<p className="number">{numberWithCommas(fbPerAvg_reaction)}</p>
	  							</div>
	  						</div>
	  						<div className="otherInfo">
	  							<p className="infoRow">
	  								<span className="profileTab icon_arrow_gray"></span>
	  								<span className="number">粉絲黏著度 {numberWithCommas(fbLoyalty)}%</span>
	  							</p>
	  							<p className="infoRow">
	  								<span className="profileTab icon_arrow_gray"></span>
	  								<span className="number">近一周談論數 {numberWithCommas(fbData.performance.TAT)}</span>
	  							</p>
	  						</div>
	  						<IconButton
	  						  className="infoIcon"
	  						  iconClassName="material-icons"
	  						  iconStyle={infoIconStyle.iconStyle}
	  						  tooltip={
	  						  	<div style={infoIconStyle.tooltipText}>
	  						  		粉絲平均互動數 : 查詢區間內，每位粉絲的平均互動數。<br/>
	  						  		粉絲黏著度 : 在全部粉絲中，(近一週)實際與粉專產生互動的粉絲比例。<br/>
	  						  		近一週談論數 : 過去一週，與粉專互動之不重複用戶數。
	  						  	</div>
	  						  }
	  						  tooltipPosition="top-left"
	  						  tooltipStyles={infoIconStyle.tooltipStyle}
	  						>
	  						  info
	  						</IconButton>
	  					</div>
  					</div>
  				</div>
  				<div className="dataBoxWrap">
  					<div className="boxContent">
	  					<p className="boxTitle">貼文相關</p>
	  					<div className="boxInfo">
	  						<div className="mainSection">
	  							<div className="profileTab fb_relevance"></div>
	  							<div className="title">
	  								<p className="item">總貼文則數</p>
	  								<p className="number">{numberWithCommas(fbData.relevance.post)}</p>
	  							</div>
	  						</div>
	  						<div className="otherInfo">
	  							<p className="infoRow">
	  								<span className="profileTab icon_arrow_gray"></span>
	  								<span className="number">相關貼文則數 {numberWithCommas(fbData.relevance.relevance)}</span>
	  							</p>
	  						</div>
	  						<IconButton
	  						  className="infoIcon"
	  						  iconClassName="material-icons"
	  						  iconStyle={infoIconStyle.iconStyle}
	  						  tooltip={
	  						  	<div style={infoIconStyle.tooltipText}>
	  						  		總貼文則數 : 查詢區間內，粉專的貼文總數。<br/>
	  						  		相關貼文則數 : 查詢區間內，查詢區間內，內文符合關鍵字的貼文則數。
	  						  	</div>
	  						  }
	  						  tooltipPosition="top-right"
	  						  tooltipStyles={infoIconStyle.tooltipStyle}
	  						>
	  						  info
	  						</IconButton>
	  					</div>
  					</div>
  				</div>
  				<div className="dataBoxWrap">
  					<div className="boxContent">
  						<p className="boxTitle">貼文互動</p>
	  					<div className="boxInfo">
	  						<div className="mainSection">
	  							<div className="profileTab fb_reaction2"></div>
	  							<div className="title">
	  								<p className="item">貼文平均互動數</p>
	  								<p className="number">{numberWithCommas(fbReatAvg_reaction)}</p>
	  							</div>
	  						</div>
	  						<div className="otherInfo">
	  							<p className="infoRow">
	  								<span className="profileTab icon_arrow_gray"></span>
	  								<span className="number">平均按讚數 {numberWithCommas(fbReaLike)}</span>
	  							</p>
	  							<p className="infoRow">
	  								<span className="profileTab icon_arrow_gray"></span>
	  								<span className="number">平均留言數 {numberWithCommas(fbReaComment)}</span>
	  							</p>
	  							<p className="infoRow">
	  								<span className="profileTab icon_arrow_gray"></span>
	  								<span className="number">平均分享數 {numberWithCommas(fbReaShare)}</span>
	  							</p>
	  						</div>
	  						<IconButton
	  						  className="infoIcon"
	  						  iconClassName="material-icons"
	  						  iconStyle={infoIconStyle.iconStyle}
	  						  tooltip={
	  						  	<div style={infoIconStyle.tooltipText}>
	  						  		貼文平均互動數 : 查詢區間內，平均每篇貼文可獲得的互動數。<br/>
	  						  		平均按讚數 : 查詢區間內，平均每篇貼文可獲得的讚數。<br/>
	  						  		平均留言數 : 查詢區間內，平均每篇貼文可獲得的留言數。<br/>
	  						  		平均分享數 : 查詢區間內，平均每篇貼文可獲得的分享數。
	  						  	</div>
	  						  }
	  						  tooltipPosition="top-right"
	  						  tooltipStyles={infoIconStyle.tooltipStyle}
	  						>
	  						  info
	  						</IconButton>
	  					</div>
  					</div>
  				</div>
  			
  				<div className="dataBoxWrap">
  					<div className="boxContent">
  						<p className="boxTitle">影片觀看</p>
	  					<div className="boxInfo">
	  						<div className="mainSection">
	  							<div className="profileTab fb_viewed"></div>
	  							<div className="title">
	  								<p className="item">影片平均觀看數</p>
	  								<p className="number">{fbViewed}</p>
	  							</div>
	  						</div>
	  						<div className="otherInfo">
	  							<p className="infoRow">
	  								<span className="profileTab icon_arrow_gray"></span>
	  								<span className="number">影片則數 {fbData.viewed.video_num === null ? 'N/A':fbData.viewed.video_num}</span>
	  							</p>
	  						</div>
	  						<IconButton
	  						  className="infoIcon"
	  						  iconClassName="material-icons"
	  						  iconStyle={infoIconStyle.iconStyle}
	  						  tooltip={
	  						  	<div style={infoIconStyle.tooltipText}>
	  						  		影片平均觀看數 : 查詢區間內，粉專影片的平均觀看數。<br/>
	  						  		影片則數 : 查詢區間內，粉專的影片總數。
	  						  	</div>
	  						  }
	  						  tooltipPosition="top-left"
	  						  tooltipStyles={infoIconStyle.tooltipStyle}
	  						>
	  						  info
	  						</IconButton>
	  					</div>
  					</div>
  				</div>
  			
  			</Tab>
		)
	}

	renderYtTab(ytData,leaderInfo){
		if(!ytData.hasOwnProperty('fans_scale')){
			return <Tab value="pane-2" label="Youtube 經營績效" />
		}
		const ytFanscale = ytData.fans_scale.fans_scale === 0 && leaderInfo.yt_hidden_subscriber === true ? '--' : numberWithCommas(ytData.fans_scale.fans_scale)
		const ytPerAvg_reaction = Math.round(ytData.performance.avg_reaction * 100) / 100
		const ytReaAvg_reaction = ytData.reaction.avg_reaction === null ? 'N/A':numberWithCommas(Math.round(ytData.reaction.avg_reaction))
		const ytReaAvg_like = ytData.reaction.avg_like === null ? 'N/A':numberWithCommas(Math.round(ytData.reaction.avg_like))
		const ytReaAvg_dislike = ytData.reaction.avg_dislike === null ? 'N/A':numberWithCommas(Math.round(ytData.reaction.avg_dislike))
		const ytReaAvg_comment = ytData.reaction.avg_comment === null ? 'N/A':numberWithCommas(Math.round(ytData.reaction.avg_comment))
		const ytViewed = ytData.viewed.viewed === null ? 'N/A':numberWithCommas(Math.round(ytData.viewed.viewed))

		return (
		 	<Tab value="pane-2" label="Youtube 經營績效">
		    <div className="dataBoxWrap">
					<div className="boxContent">
	  				<p className="boxTitle">粉絲規模</p>
  					<div className="boxInfo">
  						<div className="mainSection">
  							<div className="profileTab yt_fansScale"></div>
  							<div className="title">
  								<p className="item">訂閱人數</p>
  								<p className="number">{ytFanscale}</p>
  							</div>
  						</div>
  						<IconButton
  						  className="infoIcon"
  						  iconClassName="material-icons"
  						  iconStyle={infoIconStyle.iconStyle}
  						  tooltip={
  						  	<div style={infoIconStyle.tooltipText}>
  						  		訂閱人數 : 訂閱頻道的人數
  						  	</div>
  						  }
  						  tooltipPosition="top-right"
  						  tooltipStyles={infoIconStyle.tooltipStyle}
  						>
  						  info
  						</IconButton>
	  				</div>
  				</div>
				</div>
				<div className="dataBoxWrap">
					<div className="boxContent">
						<p className="boxTitle">粉絲成長</p>
	  					<div className="boxInfo">
	  						<div className="mainSection">
	  							<div className="profileTab yt_growth"></div>
	  							<div className="title">
	  								<p className="item">粉絲成長數</p>
	  								<p className="number">{leaderInfo.yt_hidden_subscriber === true ? '--':numberWithCommas(ytData.growth.growth)}</p>
	  							</div>
	  						</div>
	  						<IconButton
	  						  className="infoIcon"
	  						  iconClassName="material-icons"
	  						  iconStyle={infoIconStyle.iconStyle}
	  						  tooltip={
	  						  	<div style={infoIconStyle.tooltipText}>
	  						  		粉絲成長數 : 查詢區間內，訂閱者的總新增(或減少)人數。
	  						  	</div>
	  						  }
	  						  tooltipPosition="top-right"
	  						  tooltipStyles={infoIconStyle.tooltipStyle}
	  						>
	  						  info
	  						</IconButton>
	  					</div>
					</div>
				</div>
				<div className="dataBoxWrap">
					<div className="boxContent">
	  					<p className="boxTitle">粉絲經營</p>
	  					<div className="boxInfo">
	  						<div className="mainSection">
	  							<div className="profileTab yt_performance"></div>
	  							<div className="title">
	  								<p className="item">粉絲平均互動數</p>
	  								<p className="number">{leaderInfo.yt_hidden_subscriber === true ? '--':numberWithCommas(ytPerAvg_reaction)}</p>
	  							</div>
	  						</div>
	  						<IconButton
	  						  className="infoIcon"
	  						  iconClassName="material-icons"
	  						  iconStyle={infoIconStyle.iconStyle}
	  						  tooltip={
	  						  	<div style={infoIconStyle.tooltipText}>
	  						  		粉絲平均互動數 : 查詢區間內，每位粉絲的平均互動數。
	  						  	</div>
	  						  }
	  						  tooltipPosition="top-left"
	  						  tooltipStyles={infoIconStyle.tooltipStyle}
	  						>
	  						  info
	  						</IconButton>
	  					</div>
					</div>
				</div>
				<div className="dataBoxWrap">
					<div className="boxContent">
	  					<p className="boxTitle">貼文相關</p>
	  					<div className="boxInfo">
	  						<div className="mainSection">
	  							<div className="profileTab yt_relevance"></div>
	  							<div className="title">
	  								<p className="item">總影片則數</p>
	  								<p className="number">{numberWithCommas(ytData.relevance.post)}</p>
	  							</div>
	  						</div>
	  						<div className="otherInfo">
	  							<p className="infoRow">
	  								<span className="profileTab icon_arrow_gray"></span>
	  								<span className="number">相關影片則數 {numberWithCommas(ytData.relevance.relevance)}</span>
	  							</p>
	  						</div>
	  						<IconButton
	  						  className="infoIcon"
	  						  iconClassName="material-icons"
	  						  iconStyle={infoIconStyle.iconStyle}
	  						  tooltip={
	  						  	<div style={infoIconStyle.tooltipText}>
	  						  		總影片則數 : 查詢區間內，頻道的影片總數。<br/>
	  						  		相關影文則數 : 查詢區間內，內文符合關鍵字的影片總數。
	  						  	</div>
	  						  }
	  						  tooltipPosition="top-right"
	  						  tooltipStyles={infoIconStyle.tooltipStyle}
	  						>
	  						  info
	  						</IconButton>
	  					</div>
					</div>
				</div>
				<div className="dataBoxWrap">
					<div className="boxContent">
						<p className="boxTitle">貼文互動</p>
	  					<div className="boxInfo">
	  						<div className="mainSection">
	  							<div className="profileTab yt_reaction"></div>
	  							<div className="title">
	  								<p className="item">影片平均互動數</p>
	  								<p className="number">{ytReaAvg_reaction}</p>
	  							</div>
	  						</div>
	  						<div className="otherInfo">
	  							<p className="infoRow">
	  								<span className="profileTab icon_arrow_gray"></span>
	  								<span className="number">平均讚數 {ytReaAvg_like}</span>
	  							</p>
	  							<p className="infoRow">
	  								<span className="profileTab icon_arrow_gray"></span>
	  								<span className="number">平均噓數 {ytReaAvg_dislike}</span>
	  							</p>
	  							<p className="infoRow">
	  								<span className="profileTab icon_arrow_gray"></span>
	  								<span className="number">平均留言數 {ytReaAvg_comment}</span>
	  							</p>
	  						</div>
	  						<IconButton
	  						  className="infoIcon"
	  						  iconClassName="material-icons"
	  						  iconStyle={infoIconStyle.iconStyle}
	  						  tooltip={
	  						  	<div style={infoIconStyle.tooltipText}>
	  						  		貼文平均互動數 : 查詢區間內，平均每篇貼文可獲得的互動數。<br/>
	  						  		平均讚數 : 查詢區間內，平均每篇貼文可獲得的讚數。<br/>
	  						  		平均噓數 : 查詢區間內，平均每篇貼文可獲得的噓數。<br/>
	  						  		平均留言數 : 查詢區間內，平均每篇貼文可獲得的留言數。
	  						  	</div>
	  						  }
	  						  tooltipPosition="top-right"
	  						  tooltipStyles={infoIconStyle.tooltipStyle}
	  						>
	  						  info
	  						</IconButton>
	  					</div>
					</div>
				</div>
				<div className={`dataBoxWrap hiddenSubscriber ${leaderInfo.yt_hidden_subscriber === true ? 'active':''}`}>
					<div className="boxContent">
						<p className="boxTitle">影片觀看</p>
	  					<div className="boxInfo">
	  						<div className="mainSection">
	  							<div className="profileTab yt_viewed"></div>
	  							<div className="title">
	  								<p className="item">影片平均觀看數</p>
	  								<p className="number">{ytViewed}</p>
	  							</div>
	  						</div>
	  						<IconButton
	  						  className="infoIcon"
	  						  iconClassName="material-icons"
	  						  iconStyle={infoIconStyle.iconStyle}
	  						  tooltip={
	  						  	<div style={infoIconStyle.tooltipText}>
	  						  		影片平均觀看數 : 查詢區間內，頻道影片的平均觀看數。
	  						  	</div>
	  						  }
	  						  tooltipPosition="top-left"
	  						  tooltipStyles={infoIconStyle.tooltipStyle}
	  						>
	  						  info
	  						</IconButton>
  							<p className="hiddenMsg">
		  						<IconButton
										className="disabledCursor"
										iconClassName="material-icons"
										iconStyle={infoIconStyle.blueIcon}
										disableTouchRipple={true}
		  						>
		  							info
		  						</IconButton>
		  						<span className='msg'>頻道已隱藏訂閱數，粉絲規模使用最後更新之粉絲數計算、粉絲成長分數及粉絲經營分數無法計算。</span>
	  						</p>
	  					</div>
					</div>
				</div>
		  </Tab>
		)
	}

	renderIgTab(igData){
		if(!igData.hasOwnProperty('fans_scale')){
			return <Tab value="pane-3" label="Instagram 經營績效" />
		}
		const igPerAvg_reaction = Math.round(igData.performance.avg_reaction * 100) / 100
		const igReaAvg_reaction = igData.reaction.avg_reaction === null ? 'N/A': numberWithCommas(Math.round(igData.reaction.avg_reaction))
		const igReaAvg_like = igData.reaction.avg_like === null ? 'N/A': numberWithCommas(Math.round(igData.reaction.avg_like))
		const igReaAvg_comment = igData.reaction.avg_comment === null ? 'N/A': numberWithCommas(Math.round(igData.reaction.avg_comment))
		const igViewed = igData.viewed.viewed === null ? 'N/A': numberWithCommas(Math.round(igData.viewed.viewed))
		const igVideoNum = igData.viewed.video_num === null ? 'N/A': numberWithCommas(Math.round(igData.viewed.video_num))

		return (
	  		<Tab value="pane-3" label="Instagram 經營績效">
	  	   		<div className="dataBoxWrap">
  					<div className="boxContent">
	  					<p className="boxTitle">粉絲規模</p>
	  					<div className="boxInfo">
	  						<div className="mainSection">
	  							<div className="profileTab ig_fansScale"></div>
	  							<div className="title">
	  								<p className="item">追蹤人數</p>
	  								<p className="number">{numberWithCommas(igData.fans_scale.fans_scale)}</p>
	  							</div>
	  						</div>
	  						<IconButton
								className="infoIcon"
								iconClassName="material-icons"
								iconStyle={infoIconStyle.iconStyle}
								tooltip={
									<div style={infoIconStyle.tooltipText}>
										追蹤人數 : 追蹤者人數。
									</div>
								}
								tooltipPosition="top-right"
								tooltipStyles={infoIconStyle.tooltipStyle}
	  						>
	  							info
	  						</IconButton>
	  					</div>
	  				</div>
  				</div>
  				<div className="dataBoxWrap">
  					<div className="boxContent">
  						<p className="boxTitle">粉絲成長</p>
	  					<div className="boxInfo">
	  						<div className="mainSection">
	  							<div className="profileTab ig_growth"></div>
	  							<div className="title">
	  								<p className="item">粉絲成長數</p>
	  								<p className="number">{numberWithCommas(igData.growth.growth)}</p>
	  							</div>
	  						</div>
	  						<IconButton
								className="infoIcon"
								iconClassName="material-icons"
								iconStyle={infoIconStyle.iconStyle}
								tooltip={
									<div style={infoIconStyle.tooltipText}>
										粉絲成長數 : 查詢區間內，追蹤者的總新增(或減少)人數。
									</div>
								}
								tooltipPosition="top-right"
								tooltipStyles={infoIconStyle.tooltipStyle}
	  						>
	  							info
	  						</IconButton>
	  					</div>
  					</div>
  				</div>
  				<div className="dataBoxWrap">
  					<div className="boxContent">
	  					<p className="boxTitle">粉絲經營</p>
	  					<div className="boxInfo">
	  						<div className="mainSection">
	  							<div className="profileTab ig_performance"></div>
	  							<div className="title">
	  								<p className="item">粉絲平均互動數</p>
	  								<p className="number">{numberWithCommas(igPerAvg_reaction)}</p>
	  							</div>
	  						</div>
	  						<IconButton
	  							className="infoIcon"
	  							iconClassName="material-icons"
	  							iconStyle={infoIconStyle.iconStyle}
	  							tooltip={
	  								<div style={infoIconStyle.tooltipText}>
	  									粉絲平均互動數 : 查詢區間內，每位粉絲的平均互動數。
	  								</div>
	  							}
	  							tooltipPosition="top-left"
	  							tooltipStyles={infoIconStyle.tooltipStyle}
	  						>
	  							info
	  						</IconButton>
	  					</div>
  					</div>
  				</div>
  				<div className="dataBoxWrap">
  					<div className="boxContent">
	  					<p className="boxTitle">貼文相關</p>
	  					<div className="boxInfo">
	  						<div className="mainSection">
	  							<div className="profileTab ig_relevance"></div>
	  							<div className="title">
	  								<p className="item">總貼文則數</p>
	  								<p className="number">{numberWithCommas(igData.relevance.post)}</p>
	  							</div>
	  						</div>
	  						<div className="otherInfo">
	  							<p className="infoRow">
	  								<span className="profileTab icon_arrow_gray"></span>
	  								<span className="number">相關貼文則數 {numberWithCommas(igData.relevance.relevance)}</span>
	  							</p>
	  						</div>
	  						<IconButton
	  							className="infoIcon"
	  							iconClassName="material-icons"
	  							iconStyle={infoIconStyle.iconStyle}
	  							tooltip={
	  								<div style={infoIconStyle.tooltipText}>
	  									總貼文則數 : 查詢區間內，圖片及影片貼文總數。<br/>
	  									相關影文則數 : 查詢區間內，符合關鍵字的圖片及影片貼文則數。
	  								</div>
	  							}
	  							tooltipPosition="top-right"
	  							tooltipStyles={infoIconStyle.tooltipStyle}
	  						>
	  							info
	  						</IconButton>
	  					</div>
  					</div>
  				</div>
  				<div className="dataBoxWrap">
  					<div className="boxContent">
  						<p className="boxTitle">貼文互動</p>
	  					<div className="boxInfo">
	  						<div className="mainSection">
	  							<div className="profileTab ig_reaction"></div>
	  							<div className="title">
	  								<p className="item">貼文平均互動數</p>
	  								<p className="number">{igReaAvg_reaction}</p>
	  							</div>
	  						</div>
	  						<div className="otherInfo">
	  							<p className="infoRow">
	  								<span className="profileTab icon_arrow_gray"></span>
	  								<span className="number">平均愛心數 {igReaAvg_like}</span>
	  							</p>
	  							<p className="infoRow">
	  								<span className="profileTab icon_arrow_gray"></span>
	  								<span className="number">平均留言數 {igReaAvg_comment}</span>
	  							</p>
	  						</div>
	  						<IconButton
	  							className="infoIcon"
	  							iconClassName="material-icons"
	  							iconStyle={infoIconStyle.iconStyle}
	  							tooltip={
	  								<div style={infoIconStyle.tooltipText}>
	  									貼文平均互動數 : 查詢區間內，平均每篇貼文可獲得的互動數。<br/>
	  									平均愛心數 : 查詢區間內，平均每篇貼文可獲得的讚數。<br/>
	  									平均留言數 : 查詢區間內，平均每篇貼文可獲得的留言數。
	  								</div>
	  							}
	  							tooltipPosition="top-right"
	  							tooltipStyles={infoIconStyle.tooltipStyle}
	  						>
	  							info
	  						</IconButton>
	  					</div>
  					</div>
  				</div>
  				<div className="dataBoxWrap">
  					<div className="boxContent">
  						<p className="boxTitle">影片觀看</p>
	  					<div className="boxInfo">
	  						<div className="mainSection">
	  							<div className="profileTab ig_viewed"></div>
	  							<div className="title">
	  								<p className="item">影片平均瀏覽數</p>
	  								<p className="number">{igViewed}</p>
	  							</div>
	  						</div>
	  						<div className="otherInfo">
	  							<p className="infoRow">
	  								<span className="profileTab icon_arrow_gray"></span>
	  								<span className="number">影片則數 {igVideoNum}</span>
	  							</p>
	  						</div>
	  						<IconButton
	  							className="infoIcon"
	  							iconClassName="material-icons"
	  							iconStyle={infoIconStyle.iconStyle}
	  							tooltip={
	  								<div style={infoIconStyle.tooltipText}>
	  									影片平均觀看數 : 查詢區間內，影片貼文的平均觀看數。<br/>
	  									影片則數 : 查詢區間內，影片貼文的總數。
	  								</div>
	  							}
	  							tooltipPosition="top-left"
	  							tooltipStyles={infoIconStyle.tooltipStyle}
	  						>
	  							info
	  						</IconButton>
	  					</div>
  					</div>
  				</div>
	  	 	</Tab>
		)
	}

	componentDidMount(){
		const kolprofileData = this.props.kolprofile
		const source = {
			'FB':1,
			'YT':2,
			'IG':3,
		}

		Object.keys(kolprofileData).forEach((item,index)=>{
			let hideTabIndex

			if(!kolprofileData[item].hasOwnProperty('fans_scale')) {
				hideTabIndex = source[item]
				$('.sourceTab .mui-tabs__bar li:nth-child(' + hideTabIndex + ')').hide()
			}
		})

	}

	checkDefaultIndex(data) {
		const source = ['FB','YT','IG']
		let sourceTabIndex

		source.some((item,index) => {
			if(data[item].hasOwnProperty('fans_scale')){
				sourceTabIndex = index
				return true
			}
		})

		return sourceTabIndex
	}

	render () {
		const kolprofileData = this.props.kolprofile
		const leaderInfo = this.props.leaderInfo
		const fbData = kolprofileData['FB']
		const ytData = kolprofileData['YT']
		const igData = kolprofileData['IG']

	  	return (
  			<Tabs onChange={this.onChange} defaultSelectedIndex={this.checkDefaultIndex(kolprofileData)} className="profileTabWrap sourceTab">
  				{this.renderFbTab(fbData)}
  				{this.renderYtTab(ytData,leaderInfo)}
  				{this.renderIgTab(igData)}
  			</Tabs>
	    );
  	}
}



// WEBPACK FOOTER //
// ./src/components/profileSourceTab.js